/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";

// Images

function FAQ_Section2() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;
  const secondSubTitle = (text) => (
    <MKTypography
      component="div"
      color="text"
      variant="h4"
      mt={0}
      mb={1}
      fontWeight="bold"
      sx={{ textAlign: "justify" }}
    >
      {text}
    </MKTypography>
  );

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title="Property Management Frequently Asked Questions"
            contents={
              <>
                {secondSubTitle("What does property management include?")}
                We handle all aspects of managing your property, from tenant sourcing to rent
                collection, maintenance, and legal compliance. This allows you to enjoy a steady
                income without the hassle of day-to-day management.
                {lineSpacing_sm}
                {secondSubTitle("How much do your property management services cost?")}
                Our fee structure is straightforward: 8% of the monthly rental income. Additional
                charges may apply for tenant placement or specific maintenance requests. Contact us
                for a detailed breakdown.
                {lineSpacing_sm}
                {secondSubTitle("Do you manage both residential and commercial properties?")}
                Yes, we specialise in managing both residential and commercial properties to meet
                all your investment needs.
                {lineSpacing_sm}
                {secondSubTitle("Can you manage properties outside Dublin?")}
                Certainly. We provide property management services throughout Ireland, with
                expertise in local markets to help you maximise your property’s potential.
                {lineSpacing_sm}
                {secondSubTitle("How do you screen tenants?")}
                We conduct thorough tenant vetting, including background checks, credit assessments,
                and rental history verification, to ensure reliable occupants for your property.
                {lineSpacing_sm}
                {secondSubTitle("What happens if there’s a maintenance issue?")}
                Our team coordinates with trusted contractors to resolve any issues promptly. We
                offer 24/7 support for emergency repairs, giving you peace of mind.
                {lineSpacing_sm}
                {secondSubTitle("How often do you inspect properties?")}
                We perform regular inspections to ensure your property is well-maintained and
                tenants are complying with lease terms. Reports are shared with you for
                transparency.
                {lineSpacing_sm}
                {secondSubTitle("What types of properties do you manage?")}
                We manage a variety of properties, including:
                {/* <MKBox mb={2} /> */}
                <UnNumberedList
                  items={[
                    "Residential homes and apartments",
                    "Commercial offices and retail spaces",
                    "Mixed-use developments",
                  ]}
                />
                {lineSpacing_sm}
                {secondSubTitle("Can you help with off-plan properties?")}
                Yes, we provide support for off-plan property investments, including tenant sourcing
                and management once the development is complete.
                {lineSpacing_sm}
                {secondSubTitle("Why should I choose your company?")}
                With our competitive 8% fee and tailored services, we ensure your property is
                managed professionally, maximising returns while minimising stress.
                {lineSpacing_sm}
                {secondSubTitle(
                  "What is included in your residential property management services?"
                )}
                Our residential management covers tenant acquisition, lease administration, rent
                collection, routine maintenance, and legal compliance – everything you need for a
                seamless rental experience.
              </>
            }
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default FAQ_Section2;
